/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics/FctParams';
import { FaPercent } from 'react-icons/fa';
import { compoundTokens } from '../constants';
export var CollateralFactor = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'GETTER',
    method: 'markets',
    description: 'Borrow ETH or ERC20 tokens',
    supportedContracts: [
        { chainId: 1, address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B' },
    ],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'comptroller' }),
                methodParams: {
                    cToken: new FctAddress({
                        destination: 'ctoken',
                        options: compoundTokens.filter(function (token) { return token.chainId === Number(chainId); }),
                        isPreview: true,
                        icon: FaPercent
                    }),
                },
            },
            output: {
                isListed: new FctBoolean({ innerIndex: 0 }),
                collateralFactor: new FctBoolean({ innerIndex: 1, isPreview: true }),
                isComped: new FctBoolean({ innerIndex: 2 }),
            },
        });
    },
});
